import $ from 'jquery'
import 'url-polyfill'

import {
  subscribe, makePulse, shaker, loading, unloading, getCountryPrefix, getMobilePrefix, getPhonePattern,
  getOperator, getFormattedPhone
} from './utils/utilities'
import { verifySuccess, verifyError } from './utils/api-handlers'

export function main() {
  // const baseUrl = 'https://api.marvelmanager.com/aff/v2/'
  var subCheckUrl = [
    'https://', 'us-ce', 'ntral1-api', '-project',
    '-1065873315014.', 'cloudfunctions.net', '/api/', 'check-subs', 'cription'
  ].join('')
  // const baseInhouse = 'http://127.0.0.1:5000/api-project-1065873315014/europe-west3/apiV2/'
  const baseInhouse = 'https://apiv2-nagdoh6ynq-ey.a.run.app/'
  const mobileForm = document.getElementById('msisdn_form')
  const mobile = document.getElementById('mobile')
  const pinForm = document.getElementById('pin_form')
  const pin = document.getElementById('pin')
  const inValidPhone = document.getElementById('inValidPhone')
  const inValidPin = document.getElementById('inValidPin')
  const confirmPhone = document.getElementById('confirmButton')
  const confirmPin = document.getElementById('confirmPin')
  const thankyou = document.getElementById('thankyou')


  const cmp = PagePartnerCmp
  const externalToken = PagePartnerToken
  const countryCode = PageCountryCode
  const phonePattern = PagePhonePattern
  const phonePrefixes = PagePhonePrefixes
  const countryPrefix = PageCountryPrefix
  const operator = PageOperator
  const pinPattern = new RegExp(/^[0-9]{4}$/)
  const url = new URL(window.location.href)// get the page url
  // const clickId = url.searchParams.get('click_id')
  const inhouseToken = url.searchParams.get('token')
  const pubId = url.searchParams.get('pub_id')

  async function handlePhone(event) {
    event.preventDefault()

    function exposeAndShake() {
      $(inValidPhone).slideDown()
      shaker(mobileForm, inValidPhone)
    }

    // const ipAddress = (await (await fetch("https://api.ipify.org?format=json")).json()).ip;
    var inhouseData = {
      phone: getFormattedPhone(countryPrefix, countryCode, mobile.value),
      countryCode: countryCode,
      token: inhouseToken,
      trafficSource: window.location.origin,
      externalToken: externalToken,
      cmp_id: cmp,
      operator: operator,
      ua: (navigator.userAgent).toString(),
    }
    var configInhouse = {
      url: baseInhouse + 'mm-send',
      data: inhouseData,
      headers: { 'Accept': 'application/json' },
      type: 'GET',
      success: () => {
        unloading()
        $(mobileForm).slideUp()
        $(pinForm).slideDown()
        pin.addEventListener('keyup', makePulse(confirmPin))
      },
      error: (res) => {
        console.log('connection error: ', res)
        unloading()
        $(inValidPhone).slideDown()// show invalid phone div
        shaker(mobileForm, mobile)// shake these tow
      }
    }

    console.log(inhouseData);

    $(inValidPhone).slideUp()
    var validPhone = phonePattern.test(mobile.value) && new RegExp('^(' + phonePrefixes.join('|') + ')').test(mobile.value)
    if (validPhone) {
      loading()
      $.ajax(configInhouse)
    } else exposeAndShake()
  }

  function handlePin(event) {
    event.preventDefault()

    function exposeAndShake() {
      $(inValidPin).slideDown()
      shaker(pinForm, pin)
    }

    var data = {
      phone: getFormattedPhone(countryPrefix, countryCode, mobile.value),
      pin: pin.value,
    }
    var config = {
      url: baseInhouse + 'mm-verify',
      data: data,
      headers: { 'Accept': 'application/json' },
      type: 'GET',
      success: () => {
        unloading()
        $(pinForm).slideUp()
        $(thankyou).slideDown()
      },
      error: (res) => {
        console.error('response ERR:', res)
        unloading()
        $(inValidPin).slideDown()
        exposeAndShake()
      }
    }

    $(inValidPin).slideUp()
    if (pinPattern.test(pin.value)) {
      loading()
      $.ajax(config)
    } else exposeAndShake()
  }

  // handling pulse logic for both the button & input
  mobile.addEventListener('keyup', makePulse(confirmPhone)) // it takes input field as an event and button as an argument

  // whenever submit trigger the function
  confirmPhone.addEventListener('click', handlePhone)
  confirmPin.addEventListener('click', handlePin)
}
